import type { ReactNode } from "react";
import Grid from "@mui/material/Grid";

export type DashboardChartsRowProps = {
  primary: ReactNode;
  secondary: ReactNode;
};

/** Shared 8/4 chart row shell used by sabil and FMB dashboards. */
export default function DashboardChartsRow({ primary, secondary }: DashboardChartsRowProps) {
  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid
        size={{
          xs: 12,
          md: 8,
        }}
      >
        {primary}
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 4,
        }}
      >
        {secondary}
      </Grid>
    </Grid>
  );
}
